/** Returns true when the props are of type [[DayPickerMultiple]]. */
export function isDayPickerMultiple(props) {
    return props.mode === 'multiple';
}
//# sourceMappingURL=isDayPickerMultiple.js.map